import { getISOWeek } from "date-fns";

import {
  customMachineOrder,
  getDateOfISOWeek,
  isCompressedItself,
  isNotCompressedItself,
  isNotRelatedToCompressed,
  selectGroupApt,
} from "../../../../utils/function";

const fileGroupCounter = (id, osType, list) => {
  let counter = 0;

  list?.map((data) =>
    data.groupID === id ? data.machine === osType && (counter = counter + 1) : null,
  );

  return counter;
};

export const severitySelect = (decisionData) => {
  if (decisionData === 0) {
    return "not suspicious";
  } else if (decisionData === 1) {
    return "suspicious";
  } else if (decisionData === 2) {
    return "malicious";
  } else {
    return "loading";
  }
};

export const filterCustomTableData = (list) => {
  let tempList;

  tempList = list
    .filter(
      (filterData) =>
        isCompressedItself(
          filterData.compressedID,
          filterData.compressedIDfull,
          filterData.fileID,
        ) || isNotRelatedToCompressed(filterData.compressedID),
    )
    .filter(
      (filterData, index, filterArr) =>
        filterArr.findIndex((item) => item.groupID === filterData.groupID) === index,
    )
    .map((listData) => ({
      id: listData.fileID,
      user: listData.userName,
      time: listData.run_time,
      submitType:
        listData.submitType === "UI"
          ? "UI"
          : listData.submitType === "imapemail"
            ? "Email"
            : listData.submitType === "postfixemail"
              ? "Postfix Email"
              : listData.submitType === "fileshare" || listData.submitType === "winshare"
                ? "File"
                : listData.submitType === "icapweb"
                  ? "Proxy"
                  : listData.submitType === "Public API"
                    ? "Public API"
                    : null,
      hashIcon: { fileType: listData.file_name.split(".").pop() },
      file: {
        name: listData.file_name,
        hash: listData.fileHash,
        type: listData.fileType,
        url: "/statistics?data=" + listData.groupID,
      },
      groupCounter: {
        win7: fileGroupCounter(listData.groupID, "win7", list),
        win10: fileGroupCounter(listData.groupID, "win10", list),
        win11: fileGroupCounter(listData.groupID, "win11", list),
        linux22: fileGroupCounter(listData.groupID, "linux22", list),
        macos16: fileGroupCounter(listData.groupID, "macos16", list),
        andro13: fileGroupCounter(listData.groupID, "andro13", list),
      },
      progress: listData.status,
      severity: severitySelect(listData.decision),
      apt: selectGroupApt(list, listData.groupID),
    }))
    .sort((a, b) => b.time.localeCompare(a.time));

  return tempList;
};

export const filterListPopupData = (list, groupID) => {
  let tempList;
  let listTypeTags = "";
  let listNetworkTags = "";

  tempList = list
    .filter((filterData) => filterData.groupID === groupID)
    .map(
      (listData) => (
        (((listTypeTags = ""), (listNetworkTags = "")),
        listData.fileID.includes("full_triage") ? (listTypeTags = " Full Tr.") : "",
        listData.fileID.includes("high_evasion") ? (listTypeTags = " High Ev.") : "",
        listData.fileID.includes("basic_evasion") ? (listTypeTags = " Basic Ev.") : "",
        listData.fileID.includes("internet") ? (listNetworkTags = " Internet") : "",
        listData.fileID.includes("vpn") ? (listNetworkTags = " Vpn") : "",
        listData.fileID.includes("simulate") ? (listNetworkTags = " Simulate") : "",
        listData.fileID.includes("disable") ? (listNetworkTags = " Disable") : ""),
        {
          id: listData.fileID,
          networkTraffic: listNetworkTags,
          typeTag: listTypeTags,
          file: {
            name: listData.file_name,
            url: isCompressedItself(
              listData.compressedID,
              listData.compressedIDfull,
              listData.fileID,
            )
              ? "/statistics?data=" + listData.compressedIDfull + "&table=compressed"
              : "/analysis-reports?data=" +
                listData.parentID +
                "&state=" +
                severitySelect(listData.decision),
          },

          oS: listData.machine,
          progress: listData.status,
          severity: severitySelect(listData.decision),
          groupID: listData.groupID,
          compressedID: listData.compressedID,
          compressedIDfull: listData.compressedIDfull,
          apt: {
            isApt: listData.is_apt,
            aptClasses: listData.apt_classes?.[0] ? [listData.apt_classes[0]] : [],
          },
        }
      ),
    )
    .sort((a, b) => {
      if (a.typeTag === " Full Tr." && b.typeTag !== " Full Tr.") return -1;
      if (a.typeTag !== " Full Tr." && b.typeTag === " Full Tr.") return 1;

      const machineA = customMachineOrder.indexOf(a.oS);
      const machineB = customMachineOrder.indexOf(b.oS);

      return machineA - machineB;
    });

  return tempList;
};

export const filterListCompressedPopupData = (list, groupID) => {
  let tempList;
  tempList = list
    .filter(
      (filterData) =>
        filterData.compressedIDfull === groupID &&
        isNotCompressedItself(
          filterData.compressedID,
          filterData.compressedIDfull,
          filterData.fileID,
        ),
    )
    .map((listData) => ({
      id: listData.fileID,
      file: {
        name: listData.file_name,
        url: isCompressedItself(listData.compressedID, listData.compressedIDfull, listData.fileID)
          ? "/statistics?data=" + listData.compressedIDfull + "&table=compressed"
          : "/analysis-reports?data=" +
            listData.parentID +
            "&state=" +
            severitySelect(listData.decision),
        hash: listData.fileHash,
        type: listData.fileType,
      },
      oS: listData.machine,
      progress: listData.status,
      severity: severitySelect(listData.decision),
      apt: { isApt: listData.is_apt, aptClasses: listData.apt_classes },
    }));

  return tempList;
};

const getDateStringFromDateObject = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${year}-${month}-${day}`;
};

export const getDayDifference = (startDate, endDate) => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));

  return diffDays;
};

const prepareMonthlyData = (sourceData) => {
  const outputData = [];
  const responseFirstDate = new Date(`${sourceData[0]._id.year}-${sourceData[0]._id.month}-01`);
  const responseLastDate = new Date(
    `${sourceData[sourceData.length - 1]._id.year}-${
      sourceData[sourceData.length - 1]._id.month
    }-01`,
  );
  const oneMonthBefore = new Date(responseFirstDate.getTime() - 2 * 86400000); // 1 month before
  const oneMonthAfter = new Date(responseLastDate.getTime() + 31 * 86400000); // 1 month after
  outputData.push({
    _id: {
      month: oneMonthBefore.getMonth() + 1,
      year: oneMonthBefore.getFullYear(),
    },
    cleanCount: 0,
    suspiciousCount: 0,
    maliciousCount: 0,
    monthlyTotalSubmissionCount: 0,
  });
  sourceData.forEach((monthData) => outputData.push(monthData));
  outputData.push({
    _id: {
      month: oneMonthAfter.getMonth() + 1,
      year: oneMonthAfter.getFullYear(),
    },
    cleanCount: 0,
    suspiciousCount: 0,
    maliciousCount: 0,
    monthlyTotalSubmissionCount: 0,
  });
  return outputData;
};

const prepareWeeklyData = (sourceData, userStartDate, userFinishDate) => {
  let outputData = [];
  const responseFirstDate = getDateOfISOWeek(sourceData[0]._id, sourceData[0].year);

  const responseLastDate = getDateOfISOWeek(
    sourceData[sourceData.length - 1]._id,
    sourceData[sourceData.length - 1].year,
  );

  const oneMonthBefore = new Date(responseFirstDate.getTime() - 2 * 86400000); // 1 month before
  const oneMonthAfter = new Date(responseLastDate.getTime() + 31 * 86400000); // 1 month after

  outputData.push({
    _id: getISOWeek(oneMonthBefore),
    year: oneMonthBefore.getFullYear(),
    cleanCount: 0,
    suspiciousCount: 0,
    maliciousCount: 0,
    monthlyTotalSubmissionCount: 0,
  });
  sourceData.forEach((monthData) => outputData.push(monthData));
  outputData.push({
    _id: getISOWeek(oneMonthAfter),
    year: oneMonthAfter.getFullYear(),
    cleanCount: 0,
    suspiciousCount: 0,
    maliciousCount: 0,
    monthlyTotalSubmissionCount: 0,
  });

  return outputData;
};

export const prepareData = (sourceData, userStartDate, userFinishDate, filteringType) => {
  if (!sourceData.length) {
    return [];
  }

  if (filteringType === "monthly") {
    return prepareMonthlyData(sourceData);
  }

  if (filteringType === "weekly") {
    return prepareWeeklyData(sourceData, userStartDate, userFinishDate);
  }
  const outputData = [];
  const responseFirstDate = new Date(sourceData[0]._id);
  const responseLastDate = new Date(sourceData[sourceData.length - 1]._id);
  const firstDay = userStartDate <= responseFirstDate ? userStartDate : responseFirstDate;
  const lastDay = userFinishDate >= responseLastDate ? userFinishDate : responseLastDate;
  // Convert api response to object
  const sourceObj = sourceData.reduce((acc, dayData) => {
    return {
      ...acc,
      [dayData._id]: dayData,
    };
  }, {});

  let currentDay = new Date(firstDay.getTime());
  currentDay.setHours(0, 0, 0, 0);
  while (currentDay <= lastDay) {
    const dateString = getDateStringFromDateObject(currentDay);
    if (sourceObj[dateString]) {
      outputData.push(sourceObj[dateString]);
    } else {
      outputData.push({
        _id: dateString,
        cleanCount: 0,
        suspiciousCount: 0,
        maliciousCount: 0,
        dailyTotalSubmissionCount: 0,
      });
    }
    currentDay = new Date(currentDay.getTime() + 86400000); // +1 day in ms
  }
  return outputData;
};

// Finds the most recent day in the daily statistics response that actually has
// submissions. Malicious days win (that is the default table view); if there
// are none, falls back to the latest day with suspicious/clean submissions.
// Today can easily be empty, so the table should not default to it blindly.
export const getLatestDataPoint = (sourceData = []) => {
  if (!sourceData.length) return null;

  const sortedByDate = [...sourceData].sort((a, b) => String(a._id).localeCompare(String(b._id)));

  for (let i = sortedByDate.length - 1; i >= 0; i--) {
    if (sortedByDate[i].maliciousCount > 0) {
      return { date: sortedByDate[i]._id, decision: 2 };
    }
  }

  for (let i = sortedByDate.length - 1; i >= 0; i--) {
    if (sortedByDate[i].suspiciousCount > 0) {
      return { date: sortedByDate[i]._id, decision: 1 };
    }
    if (sortedByDate[i].cleanCount > 0) {
      return { date: sortedByDate[i]._id, decision: 0 };
    }
  }

  return null;
};

export const calculateTotalFileCount = (dataSet) => {
  return dataSet.reduce((accumulator, column) => {
    accumulator = accumulator + column.cleanCount + column.suspiciousCount + column.maliciousCount;
    return accumulator;
  }, 0);
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-based month
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getEndDateByStartDateStr = (startDateStr, filteringType) => {
  const baseDate = new Date(startDateStr);

  if (filteringType === "daily") {
    return startDateStr;
  } else if (filteringType === "weekly") {
    const oneWeekLater = new Date(baseDate);
    oneWeekLater.setDate(baseDate.getDate() + 7);
    const oneWeekLaterMinusOneDay = new Date(oneWeekLater);
    oneWeekLaterMinusOneDay.setDate(oneWeekLater.getDate() - 1);
    return formatDate(oneWeekLaterMinusOneDay);
  } else if (filteringType === "monthly") {
    const oneMonthLater = new Date(baseDate);
    oneMonthLater.setMonth(baseDate.getMonth() + 1);
    const oneMonthLaterMinusOneDay = new Date(oneMonthLater);
    oneMonthLaterMinusOneDay.setDate(oneMonthLater.getDate() - 1);
    return formatDate(oneMonthLaterMinusOneDay);
  } else {
    return startDateStr;
  }
};

export const getDecisionByLabel = (decisionLabel) => {
  const decision =
    decisionLabel === "Clean"
      ? 0
      : decisionLabel === "Suspicious"
        ? 1
        : decisionLabel === "Malicious"
          ? 2
          : 3;

  return decision;
};
